import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoginPageComponent } from '@app/auth/components/login-page/login-page.component';
import { UserHomeComponent } from '@app/auth/components/user-home/user-home.component';
import { AuthGuardService } from '@app/auth/guards/auth-guard.service';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: 'login', component: LoginPageComponent },
      {
        path: 'home',
        component: UserHomeComponent,
        canActivate: [AuthGuardService]
      }
    ])
  ]
})
export class AuthRoutingModule {}
